/* eslint-disable sonarjs/no-hardcoded-passwords */
export const typeOfForgotPasswordDialog = 'typeOfForgotPasswordDialog';
export const forgotPasswordDialogReducerKey = 'forgotPasswordDialogReducer';
export const forgotPasswordDialogSetEmailReducerType = 'forgotPasswordDialogSetEmailReducerType';
export const forgotPasswordDialogSetIsLoadingReducerType = 'forgotPasswordDialogSetIsLoadingReducerType';
export const forgotPasswordDialogSetResultReducerType = 'forgotPasswordDialogSetResultReducerType';
export const forgotPasswordDialogInitStateReducerType = 'forgotPasswordDialogInitStateReducerType';

export const possibleResults = {
  success: 'success',
  emailInvalid: 'invalid',
  error: 'error',
};
